import { useMutation, useQueryClient } from 'react-query';

import { endVisitTimerFetch as endTimer } from 'api/visitReports/endVisitTimer';

const useEndVisitTimer = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: endVisitTimer,
    isLoading,
  } = useMutation(endTimer, {
    onSuccess: () => {
      queryClient.invalidateQueries('visitDocs');
    },
  });

  return {
    isSuccess,
    endVisitTimer,
    isLoading,
  };
};

export default useEndVisitTimer;
